export default "__VITE_ASSET__pFVydxor__"